const ISF5ApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACE_ISF_URL}/ace-isf/isf5/response/get`,
  GET_SN: `${process.env.REACT_APP_USER_ACE_ISF_URL}/ace-isf/isf5/responseSN/get`,
};

export default ISF5ApiUrls
